<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div> 




<div class="columns">
<div class="column is-2"> <!-- begin menu-->

MENU ....




<!-- MENU  !!!! 
<div class="box">
<div style="border: 1px solid #647882;" class="columns is-mobile" v-for ="(info, index) in data_menu" :key="index">
<div  :class="{ 'activeMenu' : activeMenu == index }" class="column is-10 is-paddingless is-size-6 has-background-white-ter"> <a @click="group_data_courses(info.data, index, info.id )" style="padding-left:1.4em;">{{ info.data}}</a>
<span v-if="activeMenu == index" class="icon has-text-danger is-pulled-right"><i class="fas fa-check"></i></span>
</div>
<div class="column is-2 has-text-centered has-background-grey-lighter is-paddingless" style="border-left: 1px solid #647882;">{{info.cnt}}</div>
</div>
</div>
-->

</div>  <!-- end menu-->
<div class="column is-10"> <!-- begin data-->

RIGHT SIDE
 
</div> <!-- end data-->
</div> <!-- end content-->




</div> <!-- end main column-->

</template>


<script>
import axios from 'axios';
import CompGroup  from '@/components/Comp_Group';

export default {
        components: {  },

        data() {
            return {

            }
        },

created() {
   


},


methods: {

group_menu_group:function() {
    this.isLoading=true;
        this.groups = ''
        this.activeMenu = -1
        this.group_view='GROUP'
        this.data_menu = '';
        axios.get(this.$url+'/group_menu_groups?sess=' + this.grp_sess + '&ann='+this.grp_ann)
        .then(res => { this.data_menu = res.data
        this.isLoading=false;   }) 
},



}, // END METHODS



} // END EXPORT
</script>




<style scoped>

select {
  text-align: center;
  text-align-last: center;
  font-weight: 900;
  /* webkit*/
}
option {
  text-align: left;
  /* reset to left*/
}

</style>